window.$ = window.jQuery = require('jquery');
import dispatchFinanceModifiedEvent from '../../../core/modules/dispatch-finance-modified-event';
import { annualMileages } from '../../../modules/json/annualMileages';
import nodeListForEach from '../../../modules/nodeListForEach';
import CodeweaversResponse from './codeweavers-response';
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default class {
    constructor() {
        this.buildAnnualMileages();
        this.customerRef = '';
        this.vehicle_selector = '';
        this.deposit = false;
        this.term = false;
        this.valid_terms = [12, 18, 24, 25, 30, 31, 36, 37, 42, 48, 54, 60];
        this.mileage = false;
        this.postcode = false;
        this.age = false;
        this.term_target = false;
        this.deposit_target = false;
        this.mileage_target = false;
        this.postcode_target = false;
        this.age_target = false;
        this.finance_request = false;
        this.newVehicles = [];
        this.deposit = getCookieValue('new_deposit');
        this.defaultDeposit = window.defaultDeposit || 1260;
        this.term = getCookieValue('new_term');
        this.defaultTerm = 48;
        if (typeof defaultTerm !== 'undefined') {
            this.defaultTerm = defaultTerm;
        }
        this.mileage = getCookieValue('new_mileage');
        this.defaultMileage = 10000;
        this.age = getCookieValue('new_age');
        if (this.age !== '') {
            $("input[name='age']").val(parseInt(this.age));
        }
        this.postcode = getCookieValue('new_postcode');
        if (typeof this.postcode == 'string') {
            this.postcode = this.postcode.replace(/[^0-9a-z\s]/gi, '');
        }
        if (this.postcode !== '') {
            $("input[name='postcode']").val(this.postcode);
        }
        this.customerRef = '';
        if (typeof customerRef !== 'undefined') {
            this.customerRef = customerRef;
        }
        this.finance_request_template = {
            "Credentials":{
                "ApiKey":"ONH75GHd8x0gu6yfJ6"
                // "ApiKey":"ONH75GHd8x0gu6yfJ6"
            },
            "Customer":{
                "Reference":this.customerRef
            },
            "Parameters":{
                "Term":this.term,
                "Deposit":this.deposit,
                "DepositType":"Amount",
                "AnnualMileage":this.mileage
            },
            "VehicleRequests":[]
            };
        this.cleanFinance();
        this.setClosestMatchForSelects(document.querySelectorAll("select[name='deposit']"), this.deposit);
        $("input[name='deposit']").val(this.deposit);
        this.setClosestMatchForSelects(document.querySelectorAll("select[name='term']"), this.term);
        $("input[name='term']").val(this.term);
        this.setClosestMatchForSelects(document.querySelectorAll("select[name='mileage']"), this.mileage);
        $("input[name='mileage']").val(this.mileage);
        this.finance_products = 'Any';
        this.first_load = true;
        this.newVehicleClass = false;
        this.financeModified = false;
        this.getFinanceModified();
    }

    setNewVehicleClass(Class)
    {
        this.newVehicleClass = Class;
    }

    getFinanceParams()
    {
        return this.finance_request_template.Parameters;
    }

    setClosestMatchForSelect(sel, val)
    {
        let vals = [];
        for (let i=0, n=sel.options.length;i<n;i++) { // looping over the options
            if (sel.options[i].value) vals.push(sel.options[i].value);
        }
        sel.value = closest(val, vals);
    }

    setClosestMatchForSelects(elements, value)
    {
        if (elements instanceof HTMLElement && elements.tagName.toLowerCase() == 'select') {
            this.setClosestMatchForSelect(elements, value);
            return true;
        }
        if (elements.length == 0) {
            return;
        }
        for (let index = 0, elementsLength = elements.length; index < elementsLength; index++) {
            this.setClosestMatchForSelects(elements[index], value);
        }
    }

    buildAnnualMileages()
    {
        if (typeof annualMileages == 'undefined') {
            return false;
        }
        const els = document.querySelectorAll("[data-autofill-mileage]");
        for (let index = 0, l = els.length; index < l; index++) {
            if (typeof annualMileages[brand + '.' +els[index].dataset.autofillMileage] !== 'undefined') {
                this.fillSelectWithOptions(els[index], annualMileages[brand + '.' +els[index].dataset.autofillMileage]);
                continue;
            }
            if (typeof annualMileages['.' +els[index].dataset.autofillMileage] !== 'undefined') {
                this.fillSelectWithOptions(els[index], annualMileages['.' +els[index].dataset.autofillMileage]);
                continue;
            }
        }
    }

    fillSelectWithOptions(target, options)
    {
        $.each(options, function(v, i){
            var opt = document.createElement('option');
            opt.value = i;
            opt.innerHTML = number_format(i,0);
            target.appendChild(opt);
        });
    }

    getTerm() {
        return this.term;
    }

    getDeposit() {
        return this.deposit;
    }

    getMileage() {
        return this.mileage;
    }

    getPostcode() {
        return this.postcode;
    }

    getAge() {
        return this.age;
    }

    validNumber(num, defaultValue) {
        if (typeof num !== 'number' && typeof num == 'string') {
            num = parseFloat(num.replace(/[^0-9.]/g, ""));
        }
        if (num === '' || isNaN(num)) {
            return defaultValue;
        }
        if (num < 0) {
            return 0;
        }

        return num;
    }

    cleanTerm() {
        this.term = this.validNumber(this.term, this.defaultTerm);

        if (this.term > 60) {
            this.term = this.defaultTerm;
        }
        if (this.term < 12) {
            this.term = this.defaultTerm;
        }
        this.getNearestAllowedTerm();
    }

    cleanDeposit() {
        this.deposit = this.validNumber(this.deposit, this.defaultDeposit);
    }

    cleanMileage() {
        this.mileage = this.validNumber(this.mileage, this.defaultMileage);

        if (this.mileage > 30000) {
            this.mileage = this.defaultMileage;
        }
    }

    cleanAge() {
        this.age = this.validNumber(this.age, false);
    }

    cleanPostcode() {
        if (typeof this.postcode == 'string') {
            this.postcode = this.postcode.replace(/[^0-9a-z\s]/gi, '');
        }
    }

    cleanFinance() {
        this.cleanDeposit();
        this.cleanTerm();
        this.cleanMileage();
        this.cleanAge();
        this.cleanPostcode();
    }

    getNearestAllowedTerm()
    {
        for (let i = 0; i < this.valid_terms.length; i++) {
            if (typeof this.valid_terms[i] !== 'undefined' && this.term < this.valid_terms[i]) {
                return this.valid_terms[i];
            }
        }
        return this.defaultTerm;
    }

    getFinanceName(key) {
        if (typeof financeNames[brand + '.' + key] !== 'undefined') {
            if (financeNames[brand + '.' + key] == 'Passport') {
                return 'Passport PCP';
            }
            return financeNames[brand + '.' + key];
        }
        if (typeof financeNames['.' + key] !== 'undefined') {
            if (financeNames['.' + key] == 'Passport') {
                return 'Passport PCP';
            }
            return financeNames['.' + key];
        }
        return 'Finance';
    }

    storeFinance()
    {
        if (this.term_target !== false) {
            this.term = this.term_target.value;
        }
        if (this.deposit_target !== false) {
            this.deposit = this.deposit_target.value;
        }
        if (this.mileage_target !== false) {
            this.mileage = this.mileage_target.value;
        }
        if (this.postcode_target !== false) {
            this.postcode = this.postcode_target.value;
        }
        if (this.age_target !== false) {
            this.age = this.age_target.value;
        }
        this.cleanFinance();

        if (this.finance_products == 'JAFPCP' || this.finance_products == 'JAFPCP_TELEMATICS') {
            this.term = 37;
        }
        if (this.finance_products == 'SIMPLYDRIVE' || this.finance_products == 'SIMPLYDRIVE_TELEMATICS') {
            this.term = 36;
        }

        this.finance_request_template.Parameters.Term = this.term;
        this.finance_request_template.Parameters.Deposit = this.deposit;
        this.finance_request_template.Parameters.AnnualMileage = this.mileage;

        delete this.finance_request_template.Customer.Age;

        if (this.age !== false) {
            this.finance_request_template.Customer.Age = parseInt(this.age);
            if (this.finance_products == 'JAFPCP' || this.finance_products == 'SIMPLYDRIVE') {
                if (this.age < 18 || this.age > 75) {
                    $('.unable-to-quote-finance .young-driver').hide();
                    $('.unable-to-quote-finance .financeName').html(this.getFinanceName(this.finance_products));
                    $('.unable-to-quote-finance').modal('show');
                }
                else if (this.age >= 18 && this.age <= 20) {
                    $('.unable-to-quote-finance .youngDriverFinanceName').html(this.getFinanceName(this.finance_products+'_TELEMATICS'));
                    $('.unable-to-quote-finance .young-driver').show();
                    $('.unable-to-quote-finance .young-driver .btn').off('click').on('click', function() {
                        $('#finance-type').val(this.finance_products+'_TELEMATICS').trigger('change');
                        $('.unable-to-quote-finance').modal('hide');
                        this.getFinance();
                    }.bind(this));
                    $('.unable-to-quote-finance .financeName').html(this.getFinanceName(this.finance_products));
                    $('.unable-to-quote-finance').modal('show');
                }
            }
            else if ((this.age < 18 || this.age > 75) && (this.finance_products == 'JAFPCP_TELEMATICS' || this.finance_products == 'SIMPLYDRIVE_TELEMATICS')) {
                $('.unable-to-quote-finance .young-driver').hide();
                $('.unable-to-quote-finance .financeName').html(this.getFinanceName(this.finance_products));
                $('.unable-to-quote-finance').modal('show');
            }
        }
        delete this.finance_request_template.Customer.Postcode;
        if (this.postcode !== false && this.postcode != '') {
            this.finance_request_template.Customer.Postcode = this.postcode;
        }

        if (this.first_load) {
            this.first_load = false;
            return true;
        }

        setCookieValue('new_deposit', this.deposit);
        setCookieValue('new_mileage', this.mileage);
        setCookieValue('new_term', this.term);
        setCookieValue('new_postcode', this.postcode);
        setCookieValue('new_age', this.age);
    }

    getFinanceModified() {
        const modified = getCookieValue('new_finance_modified');
        if (modified == 'Y') {
            this.financeModified = true;
            return true;
        }
        this.financeModified = false;
        return false;
    }

    setFinanceModified(trueFalse) {
        if (trueFalse == true) {
            setCookieValue('new_finance_modified', 'Y');
            this.financeModified = true;
            dispatchFinanceModifiedEvent(true);
            return;
        }
        setCookieValue('new_finance_modified', 'N');
        dispatchFinanceModifiedEvent(false);
        this.financeModified = false;
    }

    setTerm(term)
    {
        this.term = term;
        this.cleanTerm();
    }

    /**
     * Sets the default term. If the customer has not modified the finance quote, this will also update the current term selected
     * @param {integer} term
     */
    setDefaultTerm(term = 48)
    {
        this.defaultTerm = term;
        if (!this.financeModified) {
            this.term = term;
            this.cleanTerm();
            if (this.term_target) {
                this.term_target.value = this.term;
            }
        }
    }

    bindTermToElement(target)
    {
        this.term_target = false;
        let possibleElement = document.querySelector(target);
        if (possibleElement) {
            this.term_target = possibleElement;
        }
    }

    setDeposit(deposit)
    {
        this.deposit = deposit;
        this.cleanDeposit();
    }

    /**
     * Sets the default deposit. If the customer has not modified the finance quote, this will also update the current deposit selected
     * @param {float} deposit
     */
    setDefaultDeposit(deposit = 1260)
    {
        this.defaultDeposit = deposit;
        if (!this.financeModified) {
            this.deposit = deposit;
            this.cleanDeposit();
            if (this.deposit_target) {
                this.deposit_target.value = this.deposit;
            }
        }
    }

    bindDepositToElement(target)
    {
        this.deposit_target = false;
        let possibleElement = document.querySelector(target);
        if (possibleElement) {
            this.deposit_target = possibleElement;
        }
    }

    setMileage(mileage)
    {
        this.mileage = mileage;
        this.cleanMileage();
    }

    /**
     * Sets the default mileage. If the customer has not modified the finance quote, this will also update the current mileage selected
     * @param {float} mileage
     */
    setDefaultMileage(mileage = 1260)
    {
        this.defaultMileage = mileage;
        if (!this.financeModified) {
            this.mileage = mileage;
            this.cleanMileage();
            if (this.mileage_target) {
                this.mileage_target.value = this.mileage;
            }
        }
    }

    bindMileageToElement(target)
    {
        this.mileage_target = false;
        let possibleElement = document.querySelector(target);
        if (possibleElement) {
            this.mileage_target = possibleElement;
        }
    }

    setPostcode(postcode)
    {
        this.postcode = postcode;
        this.cleanPostcode();
    }

    bindPostcodeToElement(target)
    {
        this.postcode_target = false;
        let possibleElement = document.querySelector(target);
        if (possibleElement) {
            this.postcode_target = possibleElement;
        }
    }

    setAge(age)
    {
        this.age = age;
        this.cleanAge();
    }

    bindAgeToElement(target)
    {
        this.age_target = false;
        let possibleElement = document.querySelector(target);
        if (possibleElement) {
            this.age_target = possibleElement;
        }
    }

    setVehicleSelector(selector) {
        this.vehicle_selector = selector;
    }

    addVehiclesBySelector() {
        this.newVehicles = [];
        const NewVehicle = this.newVehicleClass;
        nodeListForEach(document.querySelectorAll(this.vehicle_selector), (index,vehicle) => {
            this.newVehicles.push(new NewVehicle(vehicle));
        });
    }

    getVehicleById(id) {
        //Remove any extra strings from the vehicle ID. We have to send the finance type with the vehicle ID sometimes, when vehicle price is different depending on the finance type being submitted.
        if (typeof id == 'string') {
            const splitPoint = id.indexOf('_');
            if (splitPoint >= 0) {
                id = id.substr(0,splitPoint);
            }
        }
        for (let i = 0; i < this.newVehicles.length; i++) {
            if (typeof this.newVehicles[i] !== 'undefined' && this.newVehicles[i].getId() == id) {
                return this.newVehicles[i];
            }
        }
        return false;
    }

    getFinanceRequests() {
        // var chunkedVehicles = arrayChunk(this.newVehicles, 10);
        let financeRequests = [];
        let counter = 0;
        let financeRequestIndex = 0;
        financeRequests[financeRequestIndex] = jQuery.extend(true, {}, this.finance_request_template);
        //We need to split our request into chunks of 15. We'll step through our full vehicle array, and then through each vehicle CW object for each vehicle, and every time our counter hits 10, we create another finance request index
        this.newVehicles.forEach(vehicle => {
            vehicle.setProductsByName(this.finance_products);
            const cwVehicle = vehicle.getCodeweaversVehicleArray(this.getFinanceParams());
            // console.log('cwVehicle', cwVehicle, vehicle, this.getFinanceParams());
            if (cwVehicle === false) {
                return;
            }
            //We might have multiple requests per vehicle now, because of varying finance prices per vehicle. This means we have to step through our vehicle CW object and push each one onto the requests
            cwVehicle.forEach(data => {
                if (counter >= 15) {
                    counter = 0;
                    financeRequestIndex++;
                    financeRequests[financeRequestIndex] = jQuery.extend(true, {}, this.finance_request_template);
                }
                financeRequests[financeRequestIndex].VehicleRequests.push(data);
                counter++;
            });
        });

        return financeRequests;
    }

    setFinanceProduct(name) {
        this.finance_products = name;
    }

    setLoading() {
        this.newVehicles.forEach(vehicle => {
            vehicle.setLoading();
        });
    }

    getFinance() {
        this.storeFinance();

        this.addVehiclesBySelector();
        let requests = this.getFinanceRequests();
        this.setLoading();
        let financeCalls = [];
        for (let i = 0; i < requests.length; i += 1) {
            financeCalls.push(
                new Promise((resolve, reject) => {
                    axios({
                        method: 'post',
                        url: 'https://services.codeweavers.net/public/v3/jsonfinance/calculate',
                        data: requests[i],
                    })
                    .then(response => {
                        resolve({
                            response: response.data,
                            request: requests[i]
                        });
                    }).catch(error => {
                        console.error("CodeweaversFinance@getFinance:", error);
                        reject(error);
                    })
                })
            );
        }

        return new Promise((resolve, reject) => {
            Promise.all(financeCalls)
            .then(responses => {
                let mergedResponse = responses[0].response;
                if (responses.length > 1) {
                    for (let index = 1, len = responses.length; index < len; index++) {
                        mergedResponse.VehicleResults = mergedResponse.VehicleResults.concat(responses[index].response.VehicleResults);
                    }
                }

                this.newVehicles.forEach(vehicle => {
                    const codeweaversResponse = new CodeweaversResponse(mergedResponse, responses[0].request, vehicle, null);
                    vehicle.setCodeweaversResponse(codeweaversResponse);
                });
                resolve({
                    responses: responses,
                    vehicles: this.newVehicles
                });
            })
            .catch(errors => {
                reject(errors);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/codeweavers-finance.js